module.exports = __webpack_public_path__ + "static/media/joint.3a29a138.svg";